import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentTerm } from "src/models/General/PaymentTerm.models";

interface PaymentTermState {
  paymentTerms: IPaymentTerm[];
  paymentTermToEdit: IPaymentTerm | null;
}

const initialState: PaymentTermState = {
  paymentTerms: [],
  paymentTermToEdit: null,
};

const paymentTermSlice = createSlice({
  name: "PaymentTerm",
  initialState,
  reducers: {
    setPaymentTermList: (state, action: PayloadAction<IPaymentTerm[]>) => {
      state.paymentTerms = action.payload;
    },
    concatListPaymentTerm: (
      state: PaymentTermState,
      action: PayloadAction<IPaymentTerm[]>
    ) => {
      state.paymentTerms = [...state.paymentTerms.concat(action.payload)];
    },
    setPaymentTermToEdit: (
      state,
      action: PayloadAction<IPaymentTerm | null>
    ) => {
      state.paymentTermToEdit = action.payload;
    },
    addPaymentTerm: (state, action: PayloadAction<IPaymentTerm>) => {
      state.paymentTerms.push(action.payload);
    },
    updatePaymentTerm: (state, action: PayloadAction<IPaymentTerm>) => {
      let itemIndex = state.paymentTerms.findIndex(
        item => item.paymentTermId === action.payload.paymentTermId
      );
      if (itemIndex !== -1) state.paymentTerms[itemIndex] = action.payload;
    },
    deletePaymentTerm: (state, action: PayloadAction<number>) => {
      const newArray = state.paymentTerms.filter(
        item => item.paymentTermId !== action.payload
      );
      state.paymentTerms = newArray;
    },
  },
});

export const {
  setPaymentTermList,
  concatListPaymentTerm,
  setPaymentTermToEdit,
  addPaymentTerm,
  updatePaymentTerm,
  deletePaymentTerm,
} = paymentTermSlice.actions;

export default paymentTermSlice.reducer;
